import gql from 'graphql-tag';
import apollo from 'src/features/apollo';

const mutation = gql`
mutation createOutboundActivity($previousActivityId: ID!, $subject: String, $requestTypeId: ID!) {
  createOutboundActivity(previousActivityId: $previousActivityId, subject: $subject, requestTypeId: $requestTypeId ) {
    id
  }
}`;

function createOutboundActivity(previousActivityId, subject, requestTypeId) {
  return apollo.client.mutate({
    mutation,
    variables: { previousActivityId, subject, requestTypeId },
  }).then((res) => res.data.createOutboundActivity);
}

export default createOutboundActivity;
